import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { Expense } from 'src/app/models/Answer.model';
import { ApprovalExpenseRowComponent } from '../approval-expense-row/approval-expense-row.component';

@Component({
    selector: 'que-approval-expense-rows',
    imports: [CommonModule, ApprovalExpenseRowComponent, TranslateDirective, TranslatePipe],
    templateUrl: './approval-expense-rows.component.html',
    styleUrls: ['./approval-expense-rows.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApprovalExpenseRowsComponent {
  @Input() rows?: Expense[];
  @Input() loading = false;
  @Input() error?: string;
  @Input() canEdit = false;
  @Input() approvalId?: number;
  @Output() rowClick = new EventEmitter<void>();
}
